




import Vue, { PropType } from 'vue';
import icons from './icons';

export default Vue.extend({
  props: {
    type: String as PropType<keyof typeof icons>,
  },
  data() {
    return {
      allIcons: {},
    };
  },
  computed: {
    iconType(): string {
      return icons[this.type];
    },
  },
});
